























































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DelayedPlanOverview from '@/componentsV2/molecules/DelayedPlanOverview/DelayedPlanOverview.vue';
import DateUtils from '@/utils/DateUtils';

interface ISubscription {
  perLocationFee: number;
  nextPaymentAt: string;
}

@Component({
  components: {
    Typography,
    DelayedPlanOverview
  }
})
export default class Billing extends Vue {
  @Prop() code!: string;
  @Prop() totalLocations!: number;
  @Prop() subscription!: ISubscription;

  get tPrefix() {
    return 'modals.billing.delayedPlanOverview';
  }

  get locationsAmount() {
    return this.totalLocations || 0;
  }

  get coinsAmount() {
    const { perLocationFee } = this.subscription;

    if (!perLocationFee || !this.locationsAmount) return ' ';

    const totalFee = this.locationsAmount * perLocationFee;

    return totalFee;
  }

  get country() {
    return this.$store.getters['internationalization/getCountrySettings'];
  }

  get startMitingDate() {
    return this.getDate(this.subscription.nextPaymentAt);
  }

  getDate(date: string) {
    return DateUtils.formattedDate({
      date
    });
  }
}
